import CarBlueIcon from "@/components/common/shared/Button/SvgIcons/carBlue";

const YourVehicle = ({ t }) => {
  return (
    <div className="btnBox details">
      <div className="white-secondary-btn">
        <CarBlueIcon />
        <span>{t("vehicle.yourVehicle")}</span>
      </div>
    </div>
  );
};

export default YourVehicle;
